var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0006 11.333L82.885 22.1905L101.308 22.1554L106.968 39.6882L121.894 50.4888L116.167 67.9997L121.894 85.5105L106.968 96.3112L101.308 113.844L82.885 113.809L68.0006 124.666L53.1163 113.809L34.6928 113.844L29.0329 96.3112L14.1074 85.5105L19.834 67.9997L14.1074 50.4888L29.0329 39.6882L34.6928 22.1554L53.1163 22.1905L68.0006 11.333Z",
    fill: "#2F88FF",
    stroke: "#2D2B2B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.166 67.9997L62.3327 82.1663L90.666 53.833",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg4);
export default __webpack_public_path__ + "static/media/pg4.a841dca104f10d22461688ae4e8f8b39.svg";
export { ForwardRef as ReactComponent };